import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { INavConfig } from '../store/store';
import {
    ITreeNode,
    NavListNodeType_root,
    ITreeEdge,
    NavListNodeType_edgeLevel1,
    EdgeDirectionFWD,
    EdgeDirectionBKWD,
    NavListNodeType_nodeLevel1,
    NavListNodeType_edgeLevel2,
    NavListNodeType_nodeLevel2
} from '../model/nav.types';
import { navigationConfig } from '../config/navigation.config';
import * as _ from 'lodash';

interface IDbBase {
    _id: string;
    _key: string;
    _rev: string;
    //  [key: string]: string;
}

export interface IDbDoc extends IDbBase {
    bezeichnung: string;
    anmerkung: string;
}

interface IDbEdge extends IDbBase {
    _from: string;
    _to: string;
}


interface IGraphData {
    childs: { [key: string]: IDbDoc[] };
    edges: { [key: string]: IDbEdge[] };
    root: IDbDoc;
}

interface IData {
    nodes: { [key: string]: IDbDoc[] };
    edges: { [key: string]: IDbEdge[] };
}

@Injectable()
export class TreeDataServiceService {

    private data: IData;

    constructor(
        private http: HttpClient,
    ) { }

    public async InitializeForNode(
        config: INavConfig,
        nodeId: string,
    ) {
        try {
            const serverdata = await this.fetchData(nodeId);

            const newdata = {
                nodes: serverdata.childs,
                edges: serverdata.edges,
            } as IData;

            const rootgrp = serverdata.root._id.split('/')[0];
            if (!newdata.nodes[rootgrp]) {
                newdata.nodes[rootgrp] = [];
            }
            newdata.nodes[rootgrp].push(serverdata.root);
            this.data = newdata;

            return this.generateTreeNodes(config, this.findNodeWithID(nodeId));
        } catch (err) {
            return [];
        }
    }

    private fetchData(node: string): Promise<IGraphData> {
        return new Promise((resolve, reject) => {
            this.http.get<IGraphData>(`/api/v1/data/graph/${node}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }),
                responseType: 'json',
            }).subscribe((data) => resolve(data), (err) => reject(err));
        });
    }

    // ---------------------------------------------------------------------------------------------
    // -- generatre tree component
    // ---------------------------------------------------------------------------------------------
    private generateTreeNodes(
        config: INavConfig,
        root: IDbDoc,
    ) {
        // virtual root
        const selectedNode = root;
        const collection = root._id.split('/')[0];

        // rootNode: z.B. Meldung
        let dictItem = _.find(config.dictionary, item => item.key === collection);
        if (!dictItem) {
            // change search if root
            dictItem = _.find(config.dictionary, item => item.key === collection);
            if (!dictItem) {
                console.warn('Dictionary zur: ' + selectedNode._id + ' nicht vorhanden');
                return;
            }
        }
        let treeConfig: any;
        // MOCK, an dieser Stelle später die treeConfig aus der ClientConfig lesen
        if (collection === 'Steuerung' || collection === 'Funktionsgruppe') {
            treeConfig = [{
                root: 'Steuert',
                child: 'GehoertZu',
                replace: 'Schaltet',
                direction: 'bkwd',
                property: 'aktion',
                additional: [
                    {
                        for: 'KomponenteGA',
                        properties: {
                            typ: 'EVAK',
                        },
                        edge: 'IstIn',
                        collection: 'BereichEbene'
                    }
                ]
            }
            ];
        }
        return this.generateTreeNodesInner(config, selectedNode, collection, dictItem, treeConfig);
    }

    private generateTreeNodesInner(
        config: INavConfig,
        selectedNode: IDbDoc,
        collection: string,
        dictItemRoot: any,
        treeConfig: any[] | undefined
    ) {
        // to generate UID
        let __nodeIndex = 0;
        if (!treeConfig) {
            treeConfig = [];
        }

        // selectierter Node
        const outNodes: ITreeNode[] = [
            {
                id: __nodeIndex++,
                _id: selectedNode._id,                     // arangoID
                modeGroup: collection,           // z.B. Meldung
                nodeGroupUi: dictItemRoot.long || collection,
                nodeGroupAbbrUi: dictItemRoot.short,
                bezeichnung: selectedNode.bezeichnung,
                isExpanded: true,
                type: NavListNodeType_root,               // 'root'
                children: []
            }
        ];

        try {
            // collect Subgraph ausgehend von selectierten Node
            const edgeGroups: { [key: string]: IDbEdge[] } = {};
            let dictItem1: any = null;

            // Level 1
            this.collectEdgesOfSubGraph(
                selectedNode._id,             // seed node
                edgeGroups,                             // output: edge groups
                navigationConfig.displayDefaultEdgeGroup  // filter: all
            );

            // Auszug aus config: edgeDefinition
            let edgeDefRoot = config.edgeDefinitions[collection];
            if (!edgeDefRoot) {
                // change search if root node
                edgeDefRoot = config.edgeDefinitions[collection];
                if (!edgeDefRoot) {
                    console.warn('EdgeDefinition: "' + collection + '" nicht vorhanden');
                    return;
                }
            }

            const replace: string[] = treeConfig ? treeConfig.map(e => e.replace) : [];

            // Object für alle Objekte in edgeDefinition anlegen
            const edgeDepth1: ITreeEdge[] = [];

            for (const edgeDef in edgeDefRoot) {
                if (edgeDefRoot.hasOwnProperty(edgeDef)) {
                    dictItem1 = _.find(config.dictionary, item => item.key === edgeDef);

                    if (replace.find(e => e === edgeDef)) {
                        continue;
                    }
                    if (edgeDefRoot[edgeDef].to) {
                        edgeDepth1.push(
                            {
                                id: __nodeIndex++,
                                edgeGroupUi: dictItem1.fwd,
                                edgeGroup: edgeDef,
                                edgeDirection: EdgeDirectionFWD,
                                type: NavListNodeType_edgeLevel1,      // edgeLevel1
                                isExpanded: true,
                                children: []
                            });
                    }
                    if (edgeDefRoot[edgeDef].from) {
                        edgeDepth1.push(
                            {
                                id: __nodeIndex++,
                                edgeGroupUi: dictItem1.bkwd,
                                edgeGroup: edgeDef,
                                edgeDirection: EdgeDirectionBKWD,
                                type: NavListNodeType_edgeLevel1,      // edgeLevel1
                                isExpanded: true,
                                children: []
                            });
                    }
                }
            }

            const skipped = new Array<string>();
            const map = new Map<string, any>();

            const emptyEdgegroups = replace.filter(entry => !Object.keys(edgeGroups).some(group => group === entry));
            for (const newGroup of emptyEdgegroups) {
                edgeGroups[newGroup] = [];
            }

            // edge groups: z.B. Meldet
            for (const edgeGrp of Object.keys(edgeGroups)) {

                if (replace.some(entry => entry === edgeGrp)) {
                    skipped.push(edgeGrp);
                    continue;
                }

                // edges - level 1 ------------------------------------------------
                for (const edge of edgeGroups[edgeGrp]) {

                    let edgeDef: ITreeEdge = null;
                    let dict = null;

                    const [edgeDirection, property] = edge._from === selectedNode._id ?
                        [EdgeDirectionFWD, '_to'] : [EdgeDirectionBKWD, '_from'];

                    // hole edgeDef
                    edgeDef = edgeDepth1.find(o => o.edgeGroup === edgeGrp && o.edgeDirection === edgeDirection);
                    if (!edgeDef) {
                        continue;
                    }

                    // hole node aus containter
                    const nd = this.findNodeWithID(edge[property]);
                    const ndCollection = nd._id.split('/')[0];
                    // hole dict für node
                    dict = _.find(config.dictionary, item => item.key === ndCollection);
                    // add edge
                    const nodesDepth1: ITreeNode = {
                        id: __nodeIndex++,                     // list control id
                        _id: nd._id,                            // arangoID
                        nodeAbbr: dict.short,
                        bezeichnung: nd.bezeichnung,
                        type: NavListNodeType_nodeLevel1,      // nodeLevel1
                        refEdgeId: edge._id,
                        isExpanded: false,
                        children: []
                    };
                    edgeDef.children.push(nodesDepth1);

                    const edgeConfig = treeConfig.find(e => e.root === edgeGrp);
                    if (!edgeConfig) {
                        continue;
                    }
                    const edgedef = config.edgeDefinitions[ndCollection][edgeConfig.child];
                    if (!edgedef || !edgedef.from && !edgedef.to) {
                        continue;
                    }

                    const edgeName = config.dictionary.find(item => item.key === edgeConfig.child);
                    const edgeDepth2: ITreeEdge = {
                        id: __nodeIndex++,
                        edgeGroupUi: edgeName[edgeConfig.direction],
                        edgeGroup: edgeConfig.child,
                        edgeDirection: EdgeDirectionFWD,
                        type: NavListNodeType_edgeLevel2,
                        isExpanded: true,
                        children: []
                    };
                    nodesDepth1.children.push(edgeDepth2);
                    map.set(nd._id, { edge: edgeConfig.child, edgeGroup: edgeDepth2 });
                }
            }

            for (const [key, value] of Array.from(map)) {
                const edgeGrps: { [key: string]: IDbEdge[] } = {};
                this.collectEdgesOfSubGraph(
                    key,             // seed node
                    edgeGrps,                             // output: edge groups
                    navigationConfig.displayDefaultEdgeGroup  // filter: all
                );
                const edgeConfig = treeConfig.find(entry => entry.child === value.edge);
                const skippedEdges = skipped.find(entry => entry === edgeConfig.replace);

                const edges = edgeGrps[value.edge];
                if (!edges) {
                    value.edgeGroup.edgeGroupUi += ' ...derzeit keine Elemente';
                    continue;
                }
                for (const edge of edges) {
                    const [edgeDirection, property] = edge._from === key ? [EdgeDirectionFWD, '_to'] : [EdgeDirectionBKWD, '_from'];
                    const nodeId = edge[property];
                    const nodeCollection = nodeId.split('/')[0];

                    // hole node aus containter
                    const nd = this.findNodeWithID(nodeId);
                    // hole dict für node
                    const dict = _.find(config.dictionary, item => item.key === nodeCollection);

                    let states;
                    let replacedEdge;
                    const subtype = config.appearance.subtype[nodeCollection];
                    let uiType = dict.short;
                    if (subtype) {
                        uiType = nd[subtype];

                        if (skippedEdges) {
                            if (!this.data.edges[skippedEdges]) {
                                this.data.edges[skippedEdges] = [];
                            }
                            replacedEdge = this.data.edges[skippedEdges]
                                .find(entry => entry._from === nodeId && entry._to === selectedNode._id
                                    || entry._to === nodeId && entry._from === selectedNode._id);

                            states = [{
                                value: '-1',
                                uiMessage: '-undef-',
                            }];
                            const dicttype = config.dictionary.find(entry =>
                                entry.type === 'typeKey' && entry.collection === nodeCollection && entry.short === nd[subtype]);

                            for (const state in dicttype.aktion) {
                                if (dicttype.aktion.hasOwnProperty(state)) {
                                    states.push({
                                        value: state,
                                        uiMessage: dicttype.aktion[state]
                                    });
                                }
                            }
                        }
                    }

                    // add edge
                    const nodesDepth2: ITreeNode = {
                        id: __nodeIndex++,                     // list control id
                        _id: nd._id,                            // arangoID
                        nodeAbbr: uiType,
                        isExpanded: false,
                        bezeichnung: nd.bezeichnung,
                        type: NavListNodeType_nodeLevel2,      // nodeLevel1
                        children: [],
                        refEdgeId: replacedEdge && replacedEdge._id,
                        edgeGroup: edgeConfig.replace,
                        schaltzustaende: states,
                        schaltzustandValue: (replacedEdge && replacedEdge.aktion != null && replacedEdge.aktion.toString()) || '-1',
                    };
                    value.edgeGroup.edgeDirection = edgeDirection;

                    // additional aus Config
                    if (edgeConfig.additional) {
                        const additionalConfig = edgeConfig.additional.find((entry) => entry.for === nodeCollection &&
                            (entry.properties && entry.properties.typ ? entry.properties.typ === uiType : true));
                        if (additionalConfig) {
                            const addEdges = this.getEdgesFromNode(nd);
                            const filteredEdge = addEdges && addEdges.find((addEdge) => addEdge._id.split('/')[0] === additionalConfig.edge
                                && (additionalConfig.collection === addEdge._from.split('/')[0]
                                    || additionalConfig.collection === addEdge._to.split('/')[0]));
                            if (filteredEdge) {
                                const direction = filteredEdge._from === nd._id ? '_to' : '_from';
                                const additionalNode = this.findNodeWithID(filteredEdge[direction]);
                                if (additionalNode) {
                                    const additionalDict = _.find(config.dictionary, item => item.key === additionalNode._id.split('/')[0]);

                                    nodesDepth2.additional = additionalNode.bezeichnung;
                                    nodesDepth2.additionalAbbr = additionalDict && additionalDict.short;
                                }
                            }
                        }
                    }
                    // ---

                    value.edgeGroup.children.push(nodesDepth2);
                }
                value.edgeGroup.children = _.sortBy(value.edgeGroup.children, function (e) { return e.bezeichnung; });
            }

            // sort nodes und push to tree
            edgeDepth1.forEach(e => {
                const arr = _.sortBy(e.children, function (o) { return o.bezeichnung; });
                e.children = arr;
                outNodes[0].children.push(e);
            });

        } catch (err) {
            console.warn(err);
        }

        return outNodes;
    }


    /**
  * Selektiert Edges und Nodes ausgehend von seedNodeID und abhängig vom edgeFilter.
  * Füllt array mit zusammenhängenden Edges.
  * Füllt array mit correspondierenden Notes.
  *
  * @param seedNodeID:string[] IDs der Knotens zu denen Edges gesucht werden.
  * @param edges:string[] Array mit Edges die zu befüllen ist
  * @param nodes:string[] Array mit Nodes IDs die zu befüllen ist
  * @param edgeFilter:string Filter mit Edge-Typ
  * @returns void
  */
    private collectEdgesOfSubGraph(
        seedNodeID: string,
        outEdgesGroups: { [key: string]: IDbEdge[] },
        edgeGroupFilter: string
    ): void {
        // nodeGroups
        for (const edgeGrp of Object.keys(this.data.edges)) {

            if (edgeGroupFilter === navigationConfig.displayDefaultEdgeGroup ||
                edgeGroupFilter === edgeGrp) {

                for (const edge of this.data.edges[edgeGrp]) {

                    if (edge._to === seedNodeID || edge._from === seedNodeID) {
                        // already there?
                        if (!outEdgesGroups[edgeGrp]) {
                            outEdgesGroups[edgeGrp] = [];
                        }
                        // add edge
                        outEdgesGroups[edgeGrp].push(edge);
                    }
                }
            }
        }

    }

    /**
  * Ermittelt Knoten mit gegebener ID.
  *
  * @param nodeID ID des gesuchten Knotens.
  * @returns [INavSearchNode]
  */
    private findNodeWithID(
        nodeID: string,
    ): IDbDoc {
        const collection = nodeID.split('/')[0];
        for (const node of this.data.nodes[collection]) {
            if (node._id === nodeID) {
                return node;
            }
        }
        return null;
    }

    private getEdgesFromNode(node: IDbDoc): IDbEdge[] {
        return _.filter(
            _.flatMap(Object.keys(this.data.edges), (group) => this.data.edges[group]),
            (edge) => edge._from === node._id || edge._to === node._id
        );
    }

    public hasSchaltung(anlageId: string, sgId: string): string[] {
        if (!this.data.edges.GehoertZu || !this.data.edges.Schaltet) {
            return [];
        }
        const components = this.data.edges.GehoertZu.filter(edge => edge._to === anlageId).map(edge => edge._from);

        return this.data.edges.Schaltet.filter(edge => edge._from === sgId && components.some(comp => comp === edge._to)).map(edge => edge._id);
    }

    public getEdgeById(id: string): IDbEdge {
        const collection = id.split('/')[0];
        return this.data.edges[collection].find((edge) => id === edge._id);
    }

    public updateEdge(edge) {
        const collection = edge._id.split('/')[0];
        for (let i = 0; i < this.data.edges[collection].length; i++) {
            if (this.data.edges[collection][i]._id === edge._id) {
                this.data.edges[collection][i] = edge;
            }
        }
    }

    public addEdge(edge) {
        const collection = edge._id.split('/')[0]
        this.data.edges[collection].push(edge)
    }

    public getNodeById(id: string): IDbDoc {
        const [collection] = id.split('/');
        return this.data.nodes[collection].find((node) => node._id === id);
    }

    public clearSchaltet(id: string): string[] {
        const collection = 'Schaltet';
        const deleted: string[] = this.data.edges[collection].filter((v) => {
            return v._from === id;
        }).map((v) => v._id);
        this.data.edges[collection] = this.data.edges[collection].filter((v) => {
            return v._from !== id;
        });
        return deleted;
    }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/service/tree-data-service.service.ts